/**
 * How wide a screen's column is, declared by its route's `handle` rather than
 * by the screen: `AppLayout` owns the column, so the screen cannot widen it
 * from inside. `reading` is every screen of text, forms and single lists;
 * `wide` is the few that hold pictures, tiles or the conversation beside its
 * tutor. Only `lg` and up differ, so a phone and a tablet see one column
 * whatever the route says.
 */
export type PageWidth = 'reading' | 'wide';

const CLASSES: Record<PageWidth, string> = {
  reading: 'max-w-2xl',
  wide: 'max-w-2xl lg:max-w-5xl 2xl:max-w-7xl',
};

export function pageWidthClass(width: PageWidth): string {
  return CLASSES[width];
}

/**
 * The width the matched routes ask for, `useMatches()`'s handles in order
 * from the root. The deepest route that says wins, so a narrow child under a
 * wide layout stays narrow; one that says nothing takes its parent's.
 */
export function widthOf(handles: readonly unknown[]): PageWidth {
  for (let i = handles.length - 1; i >= 0; i--) {
    const h = handles[i];
    if (h && typeof h === 'object' && 'width' in h) {
      const w = (h as { width: unknown }).width;
      if (w === 'reading' || w === 'wide') return w;
    }
  }
  return 'reading';
}
